import '../styles/tailwind.css'
import * as React from 'react'
import { CheckCircle2Icon } from 'lucide-react'
import OauthCard from './OauthCard'
import { Alert, AlertDescription } from '@/components/ui/alert'

interface IProps {
  code: string
}

const AuthorizationSuccessApplication = ({ code }: IProps) => {
  return (
    <OauthCard
      maxWidthClassName="max-w-md text-center"
      eyebrow="Authorization complete"
      title={
        <span className="flex flex-col items-center gap-3">
          <CheckCircle2Icon className="size-10 text-primary" />
          Authorization code
        </span>
      }
    >
      <Alert>
        <AlertDescription>
          <code className="w-full text-left break-all">{code}</code>
        </AlertDescription>
      </Alert>
    </OauthCard>
  )
}

export default AuthorizationSuccessApplication
